/**
 * Pack Builder — client-side state + live totals for the Build Your Pack page.
 *
 * IMPORTANT: this file mirrors the store's real Buy-X-Get-Y discount
 * ("FREEZPACK": buy 2 from freezball-all, get the cheapest 1 at 100% off,
 * max 2 uses per order). The math here MUST agree with what checkout
 * actually charges — see brief section 02 + 08. If you change the discount
 * (different quantities, different collection), update FREE_COUNTS below
 * to match, or the page will quote a total checkout won't honor.
 */
(function () {
  'use strict';

  var FREE_COUNTS = { 1: 0, 3: 1, 6: 2 };
  var FALLBACK_COLOR_HEX = {
    navy: '#2C3F8F', blue: '#2C6FBF', purple: '#8A4FD0', pink: '#E183B8',
    red: '#C0392B', green: '#2F7D55', orange: '#F26722', black: '#241C14',
    grey: '#8D7F6C', gray: '#8D7F6C', tan: '#C9B7A0', white: '#F5EDDD'
  };

  var CURRENCY_SYMBOL = '$';
  function money(n) {
    var v = Math.round((n + 0.00001) * 100) / 100;
    var amount = v.toFixed(2);
    if (CURRENCY_SYMBOL === '\u20ac') amount = amount.replace('.', ',');
    return CURRENCY_SYMBOL + amount;
  }

  function colorSwatch(name) {
    var key = (name || '').toLowerCase().trim();
    return FALLBACK_COLOR_HEX[key] || '#A3927C';
  }

  function init(root) {
    var jsonEl = root.querySelector('[data-pack-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { console.error('Pack builder: bad JSON', e); return; }
    if (data.currencySymbol) CURRENCY_SYMBOL = data.currencySymbol;

    // Flatten every variant across every product in the collection, resolving
    // which option index is "size" and which is "color" by NAME, not position —
    // safer than assuming option1/option2 if the store's option order differs.
    var variants = [];
    (data.products || []).forEach(function (product) {
      var names = (product.optionNames || []).map(function (n) { return (n || '').toLowerCase(); });
      var sizeIdx = names.indexOf((data.sizeOptionName || 'Size').toLowerCase());
      var colorIdx = names.indexOf((data.colorOptionName || 'Color').toLowerCase());
      if (sizeIdx === -1) sizeIdx = 0;
      if (colorIdx === -1) colorIdx = 1;
      (product.variants || []).forEach(function (v) {
        variants.push({
          id: v.id,
          price: parseFloat(v.price),
          // "iss main b compare price add kr dain": each bone's own
          // original/compare-at price, now passed through from Liquid
          // (pack-builder.liquid's variants JSON), so the summary line can
          // show it struck through next to the real price — same pattern
          // already used for the refill add-on.
          compareAtPrice: parseFloat(v.compareAtPrice || 0),
          available: !!v.available,
          size: v.options[sizeIdx] || '',
          color: v.options[colorIdx] || '',
          image: v.image || '',
          productId: product.id,
          productTitle: product.title
        });
      });
    });

    if (!variants.length) {
      // Belt-and-suspenders for the Liquid-side has_products check in
      // pack-builder.liquid: that check normally catches this per-visitor
      // (e.g. Shopify Markets catalog restrictions hiding these products
      // for a shopper's market) before the page even reaches the browser,
      // but if it somehow gets here anyway, don't leave a blank/broken-
      // looking builder — show the same notice and hide the empty shell.
      console.warn('Pack builder: no variants found — check the collection setting, that it contains Freezball products, and (for international visitors) that those products are included in this shopper\'s Shopify Markets catalog.');
      root.classList.add('no-products');
      var notice = root.querySelector('[data-pb-notice]');
      if (notice) notice.removeAttribute('hidden');
      return;
    }

    var sizes = [];
    var colors = [];
    variants.forEach(function (v) {
      if (v.size && sizes.indexOf(v.size) === -1) sizes.push(v.size);
      if (v.color && colors.indexOf(v.color) === -1) colors.push(v.color);
    });

    // Optional per-page color priority ("Purple, Pink, Navy") — reorders the
    // color dots AND breaks price ties when picking the default bone, so a
    // page can lead with an in-stock color (e.g. UK: Navy M/L out of stock).
    var prefOrder = (data.colorOrder || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    function colorRank(c) { var i = prefOrder.indexOf((c || '').toLowerCase()); return i === -1 ? 999 : i; }
    if (prefOrder.length) colors.sort(function (a, b) { return colorRank(a) - colorRank(b); });

    var cheapestAvailable = variants.filter(function (v) { return v.available; }).sort(function (a, b) { return (a.price - b.price) || (colorRank(a.color) - colorRank(b.color)); })[0] || variants[0];

    function findVariant(size, color) {
      var exact = variants.find(function (v) { return v.size === size && v.color === color && v.available; });
      if (exact) return exact;
      var anyAvail = variants.find(function (v) { return v.size === size && v.color === color; });
      if (anyAvail) return anyAvail;
      return cheapestAvailable;
    }

    var refillAvailable = !!(data.refill && data.refill.variantId);

    var state = {
      tier: 3,
      slots: [],
      editingIndex: 0,
      addonOn: false
    };

    function resetSlots(tier) {
      var slots = [];
      for (var i = 0; i < tier; i++) {
        var prev = state.slots[i];
        slots.push(prev ? prev : { size: cheapestAvailable.size, color: cheapestAvailable.color });
      }
      state.slots = slots;
      state.editingIndex = Math.min(state.editingIndex, slots.length - 1);
      if (state.editingIndex < 0) state.editingIndex = 0;
    }
    resetSlots(state.tier);

    // ----- elements -----
    var tierBtns = root.querySelectorAll('[data-tier-btn]');
    var slotrow = root.querySelector('[data-slotrow]');
    var pickrow = root.querySelector('[data-pickrow]');
    var slinesEl = root.querySelector('[data-slines]');
    var totalEl = root.querySelector('[data-total]');
    var saveEl = root.querySelector('[data-save]');
    var sizeSubEl = root.querySelector('[data-size-sub]');
    var addonToggle = root.querySelector('[data-addon-toggle]');
    var addonLabel = root.querySelector('[data-addon-label]');
    var checkoutBtns = root.querySelectorAll('[data-checkout]');
    var stickyCta = root.querySelector('[data-sticky-cta]');
    var stickyTotal = root.querySelector('[data-sticky-total]');
    var summaryEl = root.querySelector('[data-summary]');

    if (!addonToggle || !refillAvailable) {
      if (addonToggle) addonToggle.style.display = 'none';
    }

    // tier "from $" prices, computed from live prices — never hard-coded.
    Object.keys(FREE_COUNTS).forEach(function (tier) {
      var el = root.querySelector('[data-tier-price="' + tier + '"]');
      if (!el) return;
      var paidCount = parseInt(tier, 10) - FREE_COUNTS[tier];
      el.textContent = 'from ' + money(cheapestAvailable.price * paidCount);
    });

    function resolvedSlots() {
      return state.slots.map(function (s, i) {
        var v = findVariant(s.size, s.color);
        return { index: i, size: v.size, color: v.color, price: v.price, compareAtPrice: v.compareAtPrice, image: v.image, variantId: v.id };
      });
    }

    function freeIndexSet(resolved) {
      // FIX (client feedback #5): the free slot(s) must always be the same
      // FIXED POSITION — bone 3 on the 3-pack, bones 5 & 6 on the 6-pack —
      // never chosen by "whichever slot is cheapest." This also fixes
      // feedback #2 for free: since the slot list and the summary lines
      // both render in index order, always putting the free slot(s) LAST
      // means they naturally land grouped together, directly above the
      // shipping line, instead of appearing wherever the cheapest pick
      // happens to be.
      var freeCount = FREE_COUNTS[state.tier] || 0;
      var set = {};
      for (var i = resolved.length - freeCount; i < resolved.length; i++) {
        if (i >= 0) set[i] = true;
      }
      return set;
    }

    function render() {
      var resolved = resolvedSlots();
      var freeSet = freeIndexSet(resolved);

      // tier buttons
      tierBtns.forEach(function (btn) {
        var t = parseInt(btn.getAttribute('data-tier-btn'), 10);
        btn.classList.toggle('sel', t === state.tier);
      });

      // slot cards
      slotrow.innerHTML = '';
      resolved.forEach(function (r) {
        var isFree = !!freeSet[r.index];
        var isEditing = r.index === state.editingIndex;
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'slot' + (isFree ? ' free' : '') + (isEditing ? ' editing' : '');
        card.setAttribute('data-slot-index', r.index);
        card.innerHTML =
          '<span class="im">' + (r.image ? '<img src="' + r.image + '" alt="" loading="lazy">' : '') + '</span>' +
          '<div class="nm">' + (isFree ? '<span class="free-tag">Free</span> ' : '') + 'Bone ' + (r.index + 1) + (isFree ? '' : ' · ' + escapeHtml(r.color)) + '</div>' +
          '<div class="mt">Size ' + escapeHtml(r.size) + ' · ' + (isFree ? 'FREE' : ((r.compareAtPrice > r.price ? '<s style="opacity:.6">' + money(r.compareAtPrice) + '</s> ' : '') + money(r.price))) + '</div>';
        card.addEventListener('click', function () {
          state.editingIndex = r.index;
          render();
        });
        slotrow.appendChild(card);
      });

      // pick row for the slot being edited
      var editing = resolved[state.editingIndex] || resolved[0];
      pickrow.innerHTML = '';
      if (editing) {
        var labSize = document.createElement('span');
        labSize.className = 'lab';
        labSize.textContent = resolved.length > 1 ? 'Editing bone ' + (editing.index + 1) + ' · Size' : 'Size';
        pickrow.appendChild(labSize);
        sizes.forEach(function (sz) {
          var hasAvail = variants.some(function (v) { return v.size === sz && v.color === editing.color && v.available; });
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pill' + (sz === editing.size ? ' on' : '');
          btn.textContent = sz;
          if (!hasAvail) btn.disabled = true;
          btn.addEventListener('click', function () {
            state.slots[editing.index].size = sz;
            render();
          });
          pickrow.appendChild(btn);
        });
        var labColor = document.createElement('span');
        labColor.className = 'lab';
        labColor.style.marginLeft = '22px';
        labColor.textContent = data.colorLabel || 'Color';
        pickrow.appendChild(labColor);
        var dots = document.createElement('span');
        dots.className = 'dots';
        colors.forEach(function (c) {
          var hasAvail = variants.some(function (v) { return v.color === c && v.size === editing.size && v.available; });
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dot' + (c === editing.color ? ' on' : '');
          dot.style.background = colorSwatch(c);
          dot.title = c;
          if (!hasAvail) dot.disabled = true;
          dot.addEventListener('click', function () {
            state.slots[editing.index].color = c;
            render();
          });
          dots.appendChild(dot);
        });
        pickrow.appendChild(dots);
      }

      // summary lines — labels match real cart line items (Freezball {size} · {color})
      slinesEl.innerHTML = '';
      resolved.forEach(function (r) {
        var isFree = !!freeSet[r.index];
        var line = document.createElement('div');
        line.className = 'sline' + (isFree ? ' free' : '');
        if (isFree) {
          // Latest client direction: a free bone should show its FULL price
          // struck through — not the (possibly reduced) current Price field
          // value. Falls back to price if no compareAtPrice is set. This is
          // still a DISPLAY-only number: /cart/add.js always adds this exact
          // variant at whatever its own Price field says in Shopify admin,
          // then the hidden discount code reduces that to $0 at checkout —
          // no theme code can make checkout charge a different amount.
          var boneFullPrice = r.compareAtPrice > r.price ? r.compareAtPrice : r.price;
          line.innerHTML = '<span>Freezball ' + escapeHtml(r.size) + ' · your pick</span>' +
            '<span><span class="strike">' + money(boneFullPrice) + '</span>FREE</span>';
        } else {
          // Reverted per client: no struck compare-at price next to a paid
          // bone anymore — single plain price, matching what checkout will
          // actually charge for this variant.
          var paidPriceHtml = (r.compareAtPrice > r.price ? '<span class="strike">' + money(r.compareAtPrice) + '</span>' : '') + money(r.price);
          line.innerHTML = '<span>Freezball ' + escapeHtml(r.size) + ' · ' + escapeHtml(r.color) + '</span><span>' + paidPriceHtml + '</span>';
        }
        slinesEl.appendChild(line);
      });
      if (state.addonOn && refillAvailable) {
        var refillLine = document.createElement('div');
        refillLine.className = 'sline';
        // Aug 31 2026 (Dan): refill add-on is the hidden $9.95 pack-builder
        // product (compare-at $14.95), so the strike here matches checkout.
        var rPrice = parseFloat(data.refill.price);
        var rComp = parseFloat(data.refill.compareAtPrice || 0);
        var rPriceHtml = (rComp > rPrice ? '<span class="strike">' + money(rComp) + '</span>' : '') + money(rPrice);
        refillLine.innerHTML = '<span>' + escapeHtml(data.refill.title || 'Bone Refills 4-pack') + '</span><span>' + rPriceHtml + '</span>';
        slinesEl.appendChild(refillLine);
      }
      if (FREE_COUNTS[state.tier] > 0) {
        var shipLine = document.createElement('div');
        shipLine.className = 'sline free';
        shipLine.innerHTML = '<span>Shipping</span><span>FREE</span>';
        slinesEl.appendChild(shipLine);
      }

      // totals
      var paidTotal = resolved.reduce(function (sum, r) { return sum + (freeSet[r.index] ? 0 : r.price); }, 0);
      var addonTotal = (state.addonOn && refillAvailable) ? parseFloat(data.refill.price) : 0;
      var total = paidTotal + addonTotal;
      // Sale-aware (Dan, Sep 1 2026): the free bone is valued at its full
      // (compare-at) price, and the sale markdown on the paid bones counts
      // toward the total saving. Both fall back automatically when the sale
      // app restores prices (compareAtPrice stops being > price).
      var savedAmount = resolved.reduce(function (sum, r) {
        var full = r.compareAtPrice > r.price ? r.compareAtPrice : r.price;
        return sum + (freeSet[r.index] ? full : 0);
      }, 0);
      var saleSave = resolved.reduce(function (sum, r) {
        if (freeSet[r.index]) return sum;
        return sum + (r.compareAtPrice > r.price ? (r.compareAtPrice - r.price) : 0);
      }, 0);

      totalEl.textContent = money(total);
      if (stickyTotal) stickyTotal.textContent = money(total);
      var refillSave = (state.addonOn && refillAvailable)
        ? Math.max(0, parseFloat(data.refill.compareAtPrice || 0) - parseFloat(data.refill.price)) : 0;
      if (savedAmount > 0 || refillSave > 0 || saleSave > 0) {
        var freeCount = FREE_COUNTS[state.tier];
        var parts = [];
        if (savedAmount > 0) parts.push(freeCount === 2 ? 'two whole bones free' : 'a whole bone free');
        if (refillSave > 0) parts.push((refillSave % 1 === 0 ? '$' + refillSave : money(refillSave)) + ' off refills');
        if (saleSave > 0.009) parts.push(money(saleSave) + ' off in the sale');
        saveEl.textContent = 'You save ' + money(savedAmount + refillSave + saleSave) + ' — ' + parts.join(' + ');
      } else {
        saveEl.textContent = '';
      }
      if (sizeSubEl) {
        var allSameSize = resolved.every(function (r) { return r.size === resolved[0].size; });
        sizeSubEl.textContent = allSameSize ? ('· Size ' + resolved[0].size) : '· Mixed sizes';
      }
      if (addonToggle) {
        addonToggle.classList.toggle('on', state.addonOn);
        if (addonLabel) addonLabel.textContent = state.addonOn ? 'Added' : 'Add';
      }

      checkoutBtns.forEach(function (btn) {
        btn.textContent = 'Add my pack — ' + money(total) + ' →';
      });
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // ----- tier switching -----
    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = parseInt(btn.getAttribute('data-tier-btn'), 10);
        if (t !== state.tier) {
          state.tier = t;
          resetSlots(t);
          render();
        }
        // Client feedback #1: clicking ANY tier card should always jump
        // down to the slot-picker/summary area — even when re-clicking the
        // tier that's already selected — since the point is getting the
        // shopper to where they actually build their pack.
        // Oct 31 2026 CRO: Clarity saw taps on the already-picked card ("from £33.90") as dead, because nothing changed until the
        // scroll started. Flash the card at once so the tap shows, then scroll.
        btn.classList.remove('fz-tap'); void btn.offsetWidth; btn.classList.add('fz-tap');
        if (!document.getElementById('fz-tap-css')) { var st = document.createElement('style'); st.id = 'fz-tap-css'; st.textContent = '.pack-builder .tier.fz-tap{animation:fzTap .45s ease}@keyframes fzTap{0%{transform:scale(1)}35%{transform:scale(.97)}100%{transform:scale(1)}}'; document.head.appendChild(st); }
        var bench = root.querySelector('.bench');
        if (bench && bench.scrollIntoView) {
          bench.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // ----- refill add-on -----
    if (addonToggle && refillAvailable) {
      addonToggle.addEventListener('click', function () {
        state.addonOn = !state.addonOn;
        render();
      });
    }

    // ----- checkout: straight to /checkout, cart page/drawer never shown -----
    //
    // Ajax-adds to cart (/cart/add.js) then redirects the browser straight to
    // /checkout — both are relative paths, so they always resolve against
    // whatever domain/market the shopper is actually browsing on. This
    // replaces the old cart-permalink (`/cart/{id}:1?storefront=true`)
    // approach, which depended on a query parameter that skip-to-checkout
    // behavior couldn't be fully re-verified for. The permalink is kept only
    // as a last-resort fallback if the Ajax add itself fails.
    //
    // Discount codes go on /checkout itself as ?discount=CODE (comma-joined
    // for two codes), NOT through the /discount/{code}?redirect= deep-link
    // this used previously. That deep-link approach turned out to be
    // fragile in exactly the way that matters here: if a code isn't a real,
    // active discount in Shopify admin yet, /discount/{code} doesn't fail
    // gracefully — it drops the shopper on the store's HOME PAGE instead of
    // continuing to checkout, even though the item was already added to
    // cart (which is why it looked like "a drawer flashes, then home").
    // ?discount= on /checkout itself degrades correctly instead: if the
    // code doesn't apply, checkout just loads without it — the shopper
    // still lands on checkout either way. Codes still need "Combinations"
    // enabled with each other in Shopify admin to both apply, and BOTH
    // FREEZPACK and WELCOME10 need to actually exist as active discounts —
    // see docs/01-shopify-admin-setup.md parts B/E.
    function checkoutTargetUrl() {
      var discountCodes = [data.discountCode];
      if (state.tier >= 3 && data.freeShippingDiscountCode) {
        discountCodes.push(data.freeShippingDiscountCode);
      }

      var url = '/checkout?discount=' + discountCodes.map(encodeURIComponent).join(',');

      try {
        var params = new URLSearchParams(window.location.search);
        params.forEach(function (value, key) {
          if (/^utm_/i.test(key)) url += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
        });
      } catch (e) { /* URLSearchParams unsupported — skip UTM passthrough */ }

      return url;
    }

    function fallbackPermalinkUrl(resolved, discountCodes) {
      // Last resort only, if the Ajax add below fails outright — old
      // cart-permalink approach, absolute URL so it still works even if
      // something's badly wrong with relative-path resolution.
      var entries = resolved.map(function (r) { return r.variantId + ':1'; });
      if (state.addonOn && refillAvailable) entries.push(data.refill.variantId + ':1');
      return data.shopUrl.replace(/\/$/, '') + '/cart/' + entries.join(',') +
        '?discount=' + discountCodes.map(encodeURIComponent).join(',') + '&storefront=true';
    }

    function goToCheckout() {
      var resolved = resolvedSlots();
      var items = resolved.map(function (r) { return { id: r.variantId, quantity: 1 }; });
      if (state.addonOn && refillAvailable) items.push({ id: data.refill.variantId, quantity: 1 });

      var discountCodes = [data.discountCode];
      if (state.tier >= 3 && data.freeShippingDiscountCode) discountCodes.push(data.freeShippingDiscountCode);

      // Cart is cleared FIRST so checkout only ever contains this pack's
      // own line items — otherwise anything the customer already had
      // sitting in their cart from earlier browsing would ride along to
      // checkout next to the pack. /cart/clear.js is Shopify's own Ajax
      // Cart endpoint for emptying the cart before the add.
      return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add.js failed with ' + res.status);
          return res.json();
        })
        .then(function () {
          window.location.href = checkoutTargetUrl();
        })
        .catch(function (err) {
          console.error('Pack builder checkout: /cart/add.js failed, falling back to permalink.', err);
          // Best-effort clear here too — if the fetch chain above failed
          // because fetch itself is blocked, this fails the same way and
          // silently no-ops; the permalink redirect below still fires
          // regardless, so checkout is never blocked on it.
          try { fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }); } catch (e) {}
          window.location.href = fallbackPermalinkUrl(resolved, discountCodes);
        });
    }

    checkoutBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.fbq) { try { fbq('track', 'InitiateCheckout'); } catch (e) {} }
        if (window.ttq) { try { ttq.track('InitiateCheckout'); } catch (e) {} }

        checkoutBtns.forEach(function (b) {
          b.disabled = true;
          b.textContent = 'Adding…';
        });

        goToCheckout().catch(function () {
          // goToCheckout already falls back internally; this only catches a
          // truly unexpected synchronous error so buttons don't stay stuck.
        }).finally(function () {
          // render() recomputes the button label from current state (it
          // always includes the live total), so this restores the correct
          // text instead of a stale cached string — and re-enables the
          // buttons for the rare case neither redirect fired (e.g. a popup
          // blocker).
          checkoutBtns.forEach(function (b) { b.disabled = false; });
          render();
        });
      });
    });

    // ----- sticky mobile CTA: show once the summary card scrolls out of view -----
    if (stickyCta && summaryEl && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
          stickyCta.classList.toggle('show', scrolledPast);
        });
      }, { threshold: 0 });
      io.observe(summaryEl);
    }

    render();

    // AddToCart pixel fires once, on first checkout intent per session-ish (on click, see above);
    // ViewContent fires once on load.
    if (window.fbq) { try { fbq('track', 'ViewContent'); } catch (e) {} }
    if (window.ttq) { try { ttq.track('ViewContent'); } catch (e) {} }
  }

  function boot() {
    document.querySelectorAll('[data-pack-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
